import React from 'react';
import HomePage from './pages/homepage/HomePage';
import FeedPage from './pages/FeedPage';
import GalleryPage from './pages/GalleryPage';
import Signup from './pages/SignupPage';
import Login from './pages/LoginPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import About from './pages/AboutPage';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import EditorPage from './pages/EditorPage';
import ArtworkPage from './pages/ArtworkPage';
import Users from './pages/Users';
import Galleries from './pages/gallery/Galleries';
import GalleryConfigAdmin from './pages/GalleryConfigAdmin';
import WelcomeMessage from './pages/WelcomeMessage';
import GalleryManagement from './pages/gallery/GalleryManagement';
import Settings from './pages/Settings';
import UserSettings from './pages/UserSettings';
import BioPage from './pages/BioPage';
import BlogPage from './pages/BlogPage';
import AdminBlogPage from './pages/AdminBlogPage';
import ViewBlogPage from './pages/ViewBlogPage';
import AllArtworksPage from './pages/AllArtworksPage';
import ArtozpherePage from './pages/artozphere/ArtozpherePage';
import ArtozphereArtworkDetail from './pages/artozphere/ArtozphereArtworkDetail';
import ArtworkStock from './pages/artozphere/ArtworkStock';
import ArtozphereCart from './components/artozphere/ArtozphereCart';
import ArtozphereCheckout from './components/artozphere/ArtozphereCheckout';
import ArtozphereCheckoutSuccess from './components/artozphere/ArtozphereCheckoutSuccess';
import { ProtectedRoute } from './auth/ProtectedRoute';

function App() {
  return (
    <div>
      <BrowserRouter>
        <div>
          <Routes>
            <Route path="/" element={<HomePage preview />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/about" element={<About />} />

            <Route element={<ProtectedRoute />}>
                <Route path="/home" element={<FeedPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/editor" element={<EditorPage />} />
                <Route path="/users" element={<Users />} />
                <Route path='/galleries' element={<Galleries />} />
                <Route path='/gallery-config' element={<GalleryConfigAdmin />} />
                <Route path='/settings' element={<Settings />} />
                <Route path='/user-settings' element={<UserSettings />} />
                <Route path="/gallery-management/:id" element={<GalleryManagement />} />
                <Route path="/artwork/:id" element={<ArtworkPage />} />
                <Route path="/artozphere" element={<ArtozpherePage />} />
                <Route path="/artozphere/cart" element={<ArtozphereCart />} />
                <Route path="/artozphere/checkout" element={<ArtozphereCheckout />} />
                <Route path="/artozphere/success" element={<ArtozphereCheckoutSuccess />} />
                <Route path="/artozphere/artwork/:artworkId/stocks" element={<ArtworkStock />} />
                <Route path="/artozphere/artwork/:artworkId" element={<ArtozphereArtworkDetail />} />
                <Route path="/bio" element={<BioPage />} />
                <Route path='/welcome' element={<WelcomeMessage />} />
                <Route path='/admin/blogs' element={<AdminBlogPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:id" element={<ViewBlogPage />} />
                <Route path="/all-artworks" element={<AllArtworksPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
